module.exports = __webpack_public_path__ + "static/media/icn_mainnav_info_small.71196a29.svg";